import { environmentData } from "@/helper/environment";
import { dateFormatWithoutOffset, isValidString } from "@/utils/date_formatter";
import { VesselScheduleServices } from "@/service/schedule/vessel_schedule_service";
import { useScheduleLocationStore } from "@/store/schedule/schedule_location_store";
import { VesselSchedule, VesselScheduleData } from "@/interface/schedule/vessel_schedule_interface";

export class VesselScheduleRepository {
  async getVesselSchedule(): Promise<VesselSchedule[]> {
    const locationStore = useScheduleLocationStore();
    const terminalId = locationStore.terminalSelected.id;
    const service = new VesselScheduleServices();
    const url = `${environmentData.domain}/tt-vessel-schedules?terminal=${terminalId}`;
    const response: VesselScheduleData = await service.fetchVesselSchedule(url);
    const vesselList = response.vesselSchedule || [];
    for (let i = 0; i < vesselList.length; i++) {
      vesselList[i].id = i;
    }
    vesselList.map((vessel) => {
      if (vessel.actualArrivalDateTimeLocal && vessel.actualArrivalDateTimeLocal !== "") {
        vessel.estimatedArrivalDateTimeLocal = vessel.actualArrivalDateTimeLocal;
        return vessel;
      }
    });
    return vesselList;
  }

  getContainerDate = (date: string): string => {
    if (isValidString(date)) {
      return dateFormatWithoutOffset(date);
    }
    return "N/A";
  };
}
